import React from 'react';
import { useTaskGrouping } from 'src/modules/shared/hooks/tasks/use-task-grouping';
import { TaskDateGroup } from '../../molecules/task-groups/task-date-group';
import { TaskStatusGroup } from '../../molecules/task-groups/task-status-group';
import type { Task } from 'src/api/generated';
import { EmptyState } from 'src/modules/shared/components/atoms/states/empty-state';
import { PiCheck } from 'react-icons/pi';

interface TasksListProps {
  tasks: Task[];
  onCreateTask?: () => void;
}

export const TasksList: React.FC<TasksListProps> = ({
  tasks,
  onCreateTask,
}) => {
  const { groupedTasks } = useTaskGrouping(tasks);

  const hasAnyTasks = tasks.length > 0;

  if (!hasAnyTasks) {
    return (
      <div className="h-full flex items-center justify-center">
        <EmptyState
          // TODO: check when implementing i18n
          title="No hay tareas"
          // TODO: check when implementing i18n
          description="Crea una tarea para empezar"
          icon={<PiCheck className="w-full h-full" />}
          // TODO: check when implementing i18n
          actionContent="Agrega una tarea"
          onAction={onCreateTask}
        />
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      {/* Date Groups (Non-completed only) */}
      {groupedTasks.dateGroups.map((group) => (
        <TaskDateGroup key={group.key} group={group} />
      ))}

      {/* Status Groups (Completed/Cancelled) */}
      {groupedTasks.statusGroups.map((group) => (
        <TaskStatusGroup key={group.status} group={group} />
      ))}
    </div>
  );
};
